<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted() {
        document.title = '继续教育实操平台';
    }
}
</script>
